/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Stats_Scope_PackagingInputs */

const vi_warehouse_stats_scope_packaging = /** @type {(inputs: Warehouse_Stats_Scope_PackagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư bao bì`)
};

/**

* @param {Warehouse_Stats_Scope_PackagingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_stats_scope_packaging = /** @type {((inputs?: Warehouse_Stats_Scope_PackagingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Stats_Scope_PackagingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_stats_scope_packaging(inputs)
});